import * as types from "./types";
import {
    getFeedbackIdAxios
} from "./services";

export async function getFeedbackIdAction({ commit }, payload) {
    commit(types.LOADING_FEEDBACK, true);
    try {
        const { data } = await getFeedbackIdAxios(payload);
        commit(types.GET_FEEDBACK_ID, data.data);
        console.log("data", data.data);
    }
    catch (e) {
        console.log(e);
        throw e;
    }
    commit(types.LOADING_FEEDBACK, false);
}